/**
 * [addEventListener]
 * @param  {[Object]}   el  [element]
 * @param  {[String]}   typ [event type]
 * @param  {Function} cb  [callback]
 * @param  {Boolean} bool  [use capture]
 * @return {[null]}       [null]
 */
export const addEvent = (el, typ, cb, bool = false) => {
  if (!el) return false
  let cancel = () => {}
  
  if (el.addEventListener) {
    el.addEventListener(typ, cb, bool)
    cancel = () => el.removeEventListener(typ, cb)
  } else if (el.attachEvent) {
    el.attachEvent(`on${typ}`, cb)
    cancel = () => el.detachEvent(`on${typ}`, cb)
  } else {
    el[`on${typ}`] = cb
    cancel = () => delete el[`on${typ}`]
  }

  return cancel
}

/**
 * [removeEventListener]
 * @param  {[Object]}   el  [element]
 * @param  {[String]}   typ [event type]
 * @param  {Function} cb  [callback]
 * @return {[null]}       [null]
 */
export const removeEvent = (el, typ, cb) => {
  if (!el) return false
  if (el.removeEventListener) {
    el.removeEventListener(typ, cb)
  } else if (el.detachEvent) {
    el.detachEvent(`on${typ}`, cb)
  } else {
    el[`on${typ}`] = null
  }
}
